import { Box, styled } from "@mui/material";

export const StyledProjects = styled(Box)(({ theme }) => ({
  width: "100%",
  h1: {
    textAlign: "center",
    paddingBlock: "1rem",
    color: theme.color.dark,
  },
  ".header": {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ".addBtn": {
      position: "absolute",
      right: "1rem",
      display: "flex",
      gap: "1rem",
    },
  },
  ".filters": {},
  ".projectsWrapper": {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "1rem",
    paddingInline: "1rem",
    maxHeight: "40rem",
    overflowY: "scroll",
  },
  [`@media screen and (max-width: ${theme.breakpoints.values.wide}px)`]: {
    ".projectsWrapper": {
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)",
      gap: "1rem",
      paddingInline: "1rem",
      maxHeight: "34rem",
      overflowY: "scroll",
    },
  },
}));
